import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=5764a300&scoped=true&"
import script from "./ItemEditor.vue?vue&type=script&lang=js&"
export * from "./ItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=5764a300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5764a300",
  null
  
)

export default component.exports